import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-596ed648"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "footer xag-page__footer nongfu-button-wrap"
}

import { onMounted } from 'vue'
import { Button } from 'vant'
import { useRouter } from 'vue-router'
import AppHeader from '@/components/Header.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'introduce',
  setup(__props) {

const $router = useRouter()
const imgList = Array(13)
  .fill(1)
  .map((val, index) => `https://static.knowledge.xag.cn/img/jijia-introduce/${index + 1}-new.jpg`)
imgList.splice(1, 0, 'https://static.knowledge.xag.cn/img/jijia-introduce/1.1-new.png')
function toBuy() {
  $router.push({
    name: 'jijia-contract',
  })
}
const canShowNext = Date.now() < 1668441600000
onMounted(() => {
  console.log('222', 222)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "极加服务介绍" }),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(imgList), (item) => {
        return (_openBlock(), _createElementBlock("img", {
          src: item,
          alt: "",
          key: item
        }, null, 8, _hoisted_2))
      }), 128))
    ]),
    canShowNext
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(Button), {
            class: "xa-vant-button",
            onClick: toBuy,
            block: "",
            type: "success"
          }, {
            default: _withCtx(() => [
              _createTextVNode("我已了解，进入下一步")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})